import escapeHtml from 'Util/escapeHtml';
import Metadata from './Metadata';

function toXml(envelope) {
  var ret = '', authContainer, auth = envelope.auth.getData();
  var requestGroup = envelope.getRequestGroup();
  var subRequests = envelope.getSubRequests();

  // hack to get container name
  for (authContainer in auth) {
    break;
  }

  var authString = xmlTagSerialize(authContainer, auth[authContainer]);

  var requestAttrs = {};
  var outputFormat = envelope.getOutputFormat();
  var errorURL     = envelope.getErrorURL();

  if (outputFormat !== 'xml')
    requestAttrs.outputFormat = outputFormat;

  if (errorURL)
    requestAttrs.errorURL = errorURL;

  ret = xmlTagSerialize('request', requestAttrs, true);
  ret += authString;

  if (subRequests.length) {
    ret += '<requestList>';

    subRequests.forEach(function(cur) {
      const methodDefinition = Metadata.getMethodDefinition(requestGroup, cur.name);
      let attributes = {};
      let children = {};
      let hasChildren = false;

      ret += '<requestItem';

      if (cur.requestID)
        ret += ' id="' + escapeHtml(cur.requestID) + '"';

      ret += '>';

      Object.entries(cur.params).forEach(([paramName, paramVal]) => {
        if (paramVal && paramVal instanceof Object) {
          hasChildren = true;
          children[paramName] = paramVal;
        } else {
          attributes[paramName] = paramVal;
        }
      });

      ret += xmlTagSerialize(cur.name, attributes, hasChildren);

      // serialize array parameter child elements
      Object.keys(children).forEach(function(paramName) {
        const paramVal = children[paramName];
        const paramDefinition = methodDefinition.parameters[paramName];


        if (Array.isArray(paramVal)) {
          ret += '<' + paramName + '>';
          paramVal.forEach(function(childElement) {
            var childAttributes = {};
            childAttributes[paramDefinition.xmlValueAttributeName] = childElement;
            ret += xmlTagSerialize(paramDefinition.xmlMainElementName, childAttributes);
          });
          ret += '</' + paramName + '>';
        } else {
          ret += xmlTagSerialize(paramName, paramVal);
        }
      });

      if (hasChildren)
        ret += '</' + cur.name + '>';

      ret += '</requestItem>';
    });

    ret += '</requestList>';
  }

  ret += '</request>';

  return ret;
}

function xmlTagSerialize(tagName, attributes, keepOpen = false) {
  let ret = `<${tagName}`;
  let children = {};
  let hasChildren = keepOpen;

  for (const [name, value] of Object.entries(attributes)) {
    if (value && value instanceof Object) {
      hasChildren = true;
      children[name] = value;
    } else {
      let attrValue;
      if (typeof value === 'boolean') {
        attrValue = value ? '1' : '0';
      } else {
        attrValue = escapeHtml(value);
      }

      ret += ` ${name}="${attrValue}"`;
    }
  }

  if (!hasChildren) {
    ret += '/';
  }

  ret += '>';

  for (const [name, value] of Object.entries(children)) {
    ret += xmlTagSerialize(name, value);
  }

  if (!keepOpen && hasChildren) {
    ret += `</${tagName}>`;
  }

  return ret;
}

function toQueryString(envelope) {
  var authParamName, authParamValue, ret = '', authContainer, auth = envelope.auth.getData();
  var subRequests = envelope.getSubRequests();
  var errorURL = envelope.getErrorURL();

  // hack to get container name
  for (authContainer in auth) {
    break;
  }

  auth = auth[authContainer];

  if (authContainer === 'authNone') {
    ret = 'authNone=1';
  } else if (authContainer === 'authToken') {
    ret = 'authToken=' + encodeURIComponent(auth.token);
  } else {
    for (authParamName in auth) {
      authParamValue = auth[authParamName];

      if (ret)
        ret += '&';

      ret += authContainer + authParamName.charAt(0).toUpperCase() + authParamName.slice(1);
      ret += '=' + encodeURIComponent(authParamValue);
    }
  }

  ret += '&outputFormat=' + encodeURIComponent(envelope.getOutputFormat());

  if (errorURL)
    ret += '&errorURL=' + encodeURIComponent(errorURL);

  if (subRequests.length !== 1)
    throw new Error('Expected exactly one subrequest');

  var subRequest = subRequests[0];

  ret += '&requestType' + '=' + encodeURIComponent(subRequest.name);

  const paramFields = getQueryString(subRequest.params);
  if (paramFields.length) {
    ret += `&${paramFields.join('&')}`;
  }

  return ret;
}

function getQueryString(object, prefix = '') {
  if (!(object instanceof Object)) {
    let value = object;
    if (typeof value === 'boolean') {
      value = value ? '1' : '0';
    } else if (value === null || value === undefined) {
      value = '';
    }
    return [ `${encodeURIComponent(prefix)}=${encodeURIComponent(value)}` ];
  }

  let ret = [];

  Object.entries(object).forEach(([name, value]) => {
    const fullName = prefix
      ? `${prefix}[${name}]`
      : name;

    if (Array.isArray(value)) {
      value.forEach((el, idx) => {
        ret = [ ...ret, ...getQueryString(el, `${fullName}[${el && el instanceof Object ? idx : ''}]`) ];
      });
    } else {
      ret = [ ...ret, ...getQueryString(value, fullName) ];
    }
  });

  return ret;
}

export default {
  serialize : function(type, envelope) {
    switch (type) {
    case 'json':
      if (envelope.getOutputFormat() === 'json')
        envelope.setOutputFormat(null);

      return JSON.stringify(envelope.getJson(), null, 2);

    case 'xml':
      return toXml(envelope);

    case 'get':
    case 'post':
      return toQueryString(envelope);
    }
  }
};
